document.addEventListener("DOMContentLoaded", function () {
  const COMPONENT_NAME = "products-bundle";
  const attributes = {
    item: `data-${COMPONENT_NAME}-item`,
    itemOptions: `data-${COMPONENT_NAME}-item-options`,
    data: `data-${COMPONENT_NAME}-data`,
  };
  class ProductsBundle extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.$items = Array.from(this.querySelectorAll(`[${attributes.item}]`));
      this.$priceReduced = document.querySelector(
        `[data-price-wrapper] [data-product-price] span`
      );
      this.$priceOriginal = document.querySelector(
        `[data-price-wrapper] [data-compare-price] span`
      );
      this.$ajaxForm = document.querySelector(
        "main-product .ajax-product-form"
      );

      this.discount = this.getAttribute("discount") || 0;
      this.masterProductId = +this.getAttribute("master-product-id");
      this.masterVariantPrice = +this.getAttribute("master-variant-price");

      this.$items.forEach(($item) => this.populateHTML($item));

      this.addEventListener("click", this.onClick.bind(this));
      this.addEventListener("change", this.onChange.bind(this));

      window.addEventListener(
        "variant:changed",
        this.onMasterVariantChange.bind(this)
      );
      this.$ajaxForm.addEventListener(
        "submit",
        this.onMasterFormSubmit.bind(this)
      );
    }

    async onMasterFormSubmit(evt) {
      let formData = {
        items: this.$items.map(($item) => ({
          id: $item.getAttribute("data-selected-variant-id"),
          quantity: 1,
        })),
      };

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    }

    onMasterVariantChange(evt) {
      const data = evt.detail;
      if (data?.product?.id !== this.masterProductId) return;

      this.masterVariantPrice = data.variant.price;
    }

    onChange(evt) {
      this.handleOptionChange(evt);
    }

    onClick(evt) {
      this.handleSwatchClick(evt);
    }

    handleOptionChange(evt) {
      const $el = evt.target.closest(".js-option[data-variant-id]");
      if (!$el) return;

      const variantId = $el.getAttribute("data-variant-id");
      const $item = $el.closest(`[${attributes.item}]`);
      const url = new URL(
        window.location.origin + $item.getAttribute(attributes.item)
      );

      url.searchParams.set("variant", variantId);
      $item.setAttribute("data-selected-variant-id", variantId);

      this.hasUnavailableVariant =
        $el.getAttribute("data-variant-available") === "false";

      this.populateHTML($item, url, true);
    }

    handleSwatchClick(evt) {
      const $el =
        evt.target.closest("[data-swatch-product-link]") ||
        evt.target.closest("[data-fake-swatch-link]");

      if (!$el) return;

      evt.preventDefault();

      const $item = $el.closest(`[${attributes.item}]`);
      const url = $el.getAttribute("href");

      $item.setAttribute(attributes.item, url);

      this.populateHTML($item, url);
    }

    populateHTML($item, url, customUrl) {
      this.setAttribute("bundle-loading", true);
      const $container = $item.querySelector(`[${attributes.itemOptions}]`);

      const newUrl = customUrl
        ? url
        : new URL(
            window.location.origin +
              (url || $item.getAttribute(attributes.item))
          );

      fetch(newUrl)
        .then((res) => res.text())
        .then((htmlText) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, "text/html");
          const $variantPicker = doc.querySelector(
            `[data-product-variant-picker]`
          );
          const price = +doc.querySelector(`[data-bundle-variant-price]`)
            .textContent;
          const variantId = +doc.querySelector("[data-bundle-variant-id]")
            .textContent;

          $item.setAttribute(
            "data-selected-variant-price",
            price || $item.getAttribute("data-selected-variant-price")
          );
          $container.innerHTML = $variantPicker.innerHTML;
          $item.setAttribute("data-selected-variant-id", variantId);
          $item.querySelector("[data-products-bundle-item-title]").textContent =
            doc.querySelector("h1.product-detail__title").textContent;
        })
        .catch((err) => console.warn(err))
        .finally(() => {
          this.updatePrice();
          this.updateButton();
          this.removeAttribute("bundle-loading");
          this.initSwatchHover();
        });
    }

    initSwatchHover() {
      const $colors = this.querySelectorAll(
        "label.opt-label.opt-swatch--image"
      );
      const $fakeSwatches = this.querySelectorAll("[data-fake-swatch-link]");

      $colors.forEach(($color) => {
        const $label =
          $color.parentElement.previousElementSibling.querySelector(
            ".js-option-title"
          );
        if (!$label) return;

        $color.addEventListener("mouseenter", () => {
          $label.innerHTML = $color.previousElementSibling.value;
        });
        $color.addEventListener("mouseleave", () => {
          $label.innerHTML = $label.getAttribute("data-default-content");
        });
      });

      $fakeSwatches.forEach(($swatch) => {
        const $label =
          $swatch.parentElement.previousElementSibling.querySelector(
            ".js-option-title"
          );
        if (!$label) return;

        $swatch.addEventListener("mouseenter", () => {
          $label.innerHTML = $swatch.textContent;
        });
        $swatch.addEventListener("mouseleave", () => {
          $label.innerHTML = $label.getAttribute("data-default-content");
        });
      });
    }

    updatePrice() {
      const bundlePrice =
        this.masterVariantPrice +
        this.$items.reduce(
          (a, $b) => a + (+$b.getAttribute("data-selected-variant-price") || 0),
          0
        );
      if (this.$priceOriginal) {
        this.$priceOriginal.innerHTML = theme.Shopify.formatMoney(
          bundlePrice,
          theme.moneyFormatWithCodeForProductsPreference
        );
      }
      if (this.$priceReduced) {
        this.$priceReduced.innerHTML = theme.Shopify.formatMoney(
          this.calculatedDiscountedPrice(bundlePrice),
          theme.moneyFormatWithCodeForProductsPreference
        );
      }
    }

    updateButton() {
      window.updateProductBtnStatus(
        this.$ajaxForm.querySelector("[data-add-to-cart]"),
        !this.hasUnavailableVariant
      );
    }

    calculatedDiscountedPrice(price) {
      if (this.discount.includes("%")) {
        const discount = parseFloat(this.discount.replace("%", ""));
        return price - price * (discount / 100);
      }
      if (this.discount.includes("$")) {
        const discount = parseFloat(this.discount.replace("$", ""));
        return price - discount;
      }
      return price;
    }
  }

  customElements.define(COMPONENT_NAME, ProductsBundle);
});
